import * as Yup from 'yup';

export const validationSchema2 = () =>
  Yup.object({
    tenantUserId: Yup.string().required('Required').nullable(),
    cardFullName: Yup.string().required('Required').nullable(),
    departmentId: Yup.string().required('Required').nullable(),
  });